<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <!-- <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Municipio</mat-label>
                <input matInput formControlName="a4MunicipioLocalizacion">
            </mat-form-field> -->
            
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Municipio*</mat-label>
                <input matInput formControlName="a4MunicipioLocalizacion" [matAutocomplete]="autoMunicipio">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                
                <mat-autocomplete #autoMunicipio="matAutocomplete" [displayWith]="displayFn" (optionSelected)="changeMunicipio($event)">
                    <mat-option *ngFor="let option of municipioFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Localidad</mat-label>
                <input matInput formControlName="a4LocalidadLocalizacion">
            </mat-form-field> -->
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Localidad</mat-label>
                <input matInput formControlName="a4LocalidadLocalizacion" [matAutocomplete]="autoLocalidad">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoLocalidad="matAutocomplete" [displayWith]="displayFn" (optionSelected)="changeLocalidad($event)">
                    <mat-option *ngFor="let option of localidadFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <!-- <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Colonia</mat-label>
                <input matInput formControlName="a4ColoniaLocalizacion">
            </mat-form-field> -->

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Colonia</mat-label>
                <input matInput formControlName="a4ColoniaLocalizacion" [matAutocomplete]="autoColonia">
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #autoColonia="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of coloniaFilteredOptions$ | async" [value]="option">
                        <span>{{option.label}}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Código Postal*</mat-label>
                <input matInput formControlName="a4CodigoPostalLocalizacion">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Calle*</mat-label>
                <input matInput formControlName="a4CalleLocalizacion">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Número Exterior*</mat-label>
                <input matInput formControlName="a4NumeroExteriorLocalizacion">
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
            <mat-form-field appearance="outline" fxFlex="50" class="px-4">
                <mat-label>Número Interior</mat-label>
                <input matInput formControlName="a4NumeroInteriorLocalizacion">
            </mat-form-field>
        </div>
    </div>
</form>
